import React from 'react';
export var CollapseGroupContext = /*#__PURE__*/React.createContext({
  isGroup: false,
  value: [],
  onCollapse: function onCollapse() {}
});